"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[2989],{

/***/ 2921
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class ToastsController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ['successTemplate', 'errorTemplate', 'warningTemplate', 'infoTemplate', 'container']

  show(title, subtitle = '', type = 'info') {
    const toast = this[`${type}TemplateTarget`].content.cloneNode(true)
    toast.querySelector('.title').textContent = title
    toast.querySelector('.subtitle').textContent = subtitle
    
    if (subtitle) {
      toast.querySelector('.subtitle').classList.remove('hidden')
    } else {
      toast.querySelector('.subtitle').classList.add('hidden')
    }

    // Firstly, add the toast to the container
    this.containerTarget.appendChild(toast)
    
    // Get the newly added toast element
    const toastElement = this.containerTarget.lastElementChild

    // Then, trigger the opening animation
    setTimeout(() => { toastElement.setAttribute('data-open', 'true') }, 100)

    // Set timeout to animate out and remove the toast
    setTimeout(() => { toastElement.removeAttribute('data-open') }, 5000)

    // Finally, remove the toast from the DOM after the animation completes (300ms after removing the data-open attribute)
    setTimeout(() => { toastElement.remove() }, 5300)
  }

  close(event) {
    // Get the toast element to be closed
    const toastElement = event.currentTarget.closest('div[role="alert"]')

    // Animate out the toast
    toastElement.removeAttribute('data-open')

    // Remove the toast from the DOM after the animation completes
    setTimeout(() => { toastElement.remove() }, 300)
  }
}

Stimulus.register('toasts', ToastsController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(2921)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);